import React from 'react'
import { Link } from 'react-router-dom'

import { BlockComponentsRole75Checker } from 'components'

export default function BlockedLinkWrapper({ to, isClickBlocked, children, className, onClick }) {
  return (
    <BlockComponentsRole75Checker isClickBlocked={isClickBlocked} tooltipPositionClassname="tooltippedE">
      <Link to={to} className={className} onClick={onClick}>
        {children}
      </Link>
    </BlockComponentsRole75Checker>
  )
}
